<div mat-dialog-content style="position: relative;">
    <div fxLayout="row" fxLayoutAlign="space-around center"
        style="height:100%; position: absolute; left: 50%; z-index: 999;" *ngIf="loading">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
    <div [style.visibility.hidden]="loading">
        <app-smart-map [height]="height" [width]="width" [isClickable]="!data?.disablePinClick"
         [addMyMarker]="false" [setMapTypeControl]="true" [setScaleControl]="false"
            [currentGeoLocation]="geoLocation" [setCenter]="setCenterJson" [changeCenterAddPin]="changeCenterAddPinValue"
            (mapSelect)="onMapSelect($event)" (geoLocation)="onGeoLocation($event)"
            (tilesloaded)="onTilesLoaded()"
            *ngIf="geoLocation.lat && geoLocation.lng">
        </app-smart-map>
    </div>
</div>
<div mat-dialog-actions>
    <div fxLayout="row" fxFlex fxLayoutGap="0px">
        <div fxFlex align="right">
            <button class="green-text" mat-raised-button color="primary" (click)="onConfirm()"
                *ngIf="data?.enableConfirm">{{'Submit' |
                translate}}</button>
            <button class="red-text" mat-raised-button mat-dialog-close>{{'Close' | translate}}</button>
        </div>
    </div>
</div>
